import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useWorkspace } from "@/contexts/WorkspaceContext";
import { toast } from "sonner";

export default function CreateListDialog({ open, folderId, onOpenChange }) {
  const navigate = useNavigate();
  const { refreshTree } = useWorkspace();
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!folderId || !name.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.post(`/folders/${folderId}/lists`, { name: name.trim() });
      toast.success("List created");
      await refreshTree();
      setName("");
      onOpenChange(false);
      navigate(`/list/${data.list.id}`);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed to create list");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-sm" data-testid="create-list-dialog">
        <DialogHeader>
          <DialogTitle className="font-display tracking-tight">New list</DialogTitle>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <Label className="font-mono-data text-[10px] uppercase tracking-[0.2em] text-neutral-500">Name</Label>
            <Input
              autoFocus
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Sprint 24"
              className="mt-1 rounded-sm h-10"
              data-testid="create-list-name-input"
            />
            <p className="text-xs text-neutral-500 mt-2">A default workflow (To Do → In Progress → In Review → Done) will be added. You can customise it later.</p>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} className="rounded-sm">Cancel</Button>
            <Button type="submit" disabled={busy || !name.trim()} className="rounded-sm bg-neutral-950 hover:bg-neutral-800" data-testid="create-list-submit">
              {busy ? "Creating…" : "Create list"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
